import { Transfer } from "gen/txn/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchTransfers } from "features/api/search"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useTransferFilter({
  persistInUrl = true,
  key = "transfer",
  label = "Transfer",
  initialSelectedOptions = [],
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    "persistInUrl" | "key" | "label" | "initialSelectedOptions"
  >
> = {}) {
  const { results, setQuery, loadNext } = useSearchTransfers()

  const transfers = useMemo(() => {
    const transfers: Transfer[] = []
    for (const { transfer } of results) {
      if (!transfer) continue
      transfers.push(transfer)
    }
    return transfers
  }, [results])

  const { filter, selected: selectedTransferIds } = useIdFilter({
    key,
    label,
    values: transfers,
    labelExtractor: (transfer) => transfer.identifier,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    onLoadMore: loadNext,
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })

  return { filter, selectedTransferIds }
}
